import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

const HighRiskComponent = ({ 
  high_risk_vehicles,
  threshold,
  btn = true
}) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate("/high-risk");
  };

  return (
    <div className="high-risk-component">
      <div className="high-risk-component-inner">
        <div className="left">
          <div className="head">
            <div className="title">
              High-Risk Activity Detected in {high_risk_vehicles} Vehicles
            </div>
            <div className="subtitle">
              Immediate verification required. System flagged suspicious
              behavior based on AI scoring ({threshold}+).
            </div>
          </div>
          {btn && <Button onClick={handleViewDetails}>View Details</Button>}
        </div>
        <div className="right">
          <span>{threshold}+</span>
        </div>
      </div>
    </div>
  );
};

export default HighRiskComponent;
